import { useMutation } from '@tanstack/react-query';

import Banner from 'components/shared/ai/Banner';
import AIPrompt from 'models/AIPrompt';
import { createUserResourceView } from 'services/api/userResourceViews';

const TOOLTIP_TEXT =
  'The summary does not create new information and is generated solely from the attached sources. Please review and confirm that it is accurate and appropriate for your intended use.';

type ExplainerProps = {
  title: string;
  aiPrompt?: AIPrompt;
  hasBeenCollapsed?: boolean;
  onCollapseSuccess?: () => void;
};

export default function Explainer({ aiPrompt, onCollapseSuccess, ...props }: ExplainerProps) {
  const { mutate } = useMutation({
    mutationFn: createUserResourceView,
    onSuccess: onCollapseSuccess,
  });

  const handleCollapseHeader = () => {
    mutate({
      resourceId: aiPrompt?.id ?? '',
      resourceType: 'AIPrompt',
    });
  };

  return (
    <Banner onCollapseHeader={handleCollapseHeader} titleTooltip={TOOLTIP_TEXT} {...props}>
      {aiPrompt?.explainer}
    </Banner>
  );
}
